import type { EMetricKey } from '~/types/metric';

import { GTooltipCard } from '~/presentation/ui/components/GTooltip';
import { DragHandleIcon, InfoIcon } from '@shopify/polaris-icons';
import { GDiv, type GTooltipCardData } from '~/presentation/ui';
import { TruncatedCheckbox } from './TruncatedCheckbox';
import { Draggable } from 'react-beautiful-dnd';
import { Box, Icon } from '@shopify/polaris';
import { cls } from '~/utils';
import { memo } from 'react';

interface IMetricItemProps {
  value: EMetricKey;
  index: number;
  label: string;
  tooltip: GTooltipCardData;
  draftSelectedMetrics: string[];
  isHovered: boolean;
  handleToggleMetric: (value: EMetricKey) => void;
  setHoveredItem: (value: EMetricKey | null) => void;
}
export const MetricItem = memo(
  ({
    value,
    index,
    label,
    tooltip,
    draftSelectedMetrics,
    handleToggleMetric,
    setHoveredItem,
    isHovered,
  }: IMetricItemProps) => {
    return (
      <Draggable key={value} draggableId={value} index={index}>
        {(provided, snapshot) => {
          return (
            <GDiv
              ref={provided.innerRef}
              {...provided.draggableProps}
              className={cls(
                'mb-1 p-[6px] pr-[10px] rounded-lg cursor-pointer',
                snapshot.isDragging ? 'opacity-80 bg-gray-50' : 'opacity-100 bg-transparent',
                { 'bg-surface-hover': isHovered || snapshot.isDragging },
              )}
              onMouseEnter={() => setHoveredItem(value)}
              onMouseLeave={() => setHoveredItem(null)}
              onClick={() => handleToggleMetric(value)}
            >
              <div className="flex justify-between items-center gap-2">
                <div className="min-w-0 flex-1">
                  <TruncatedCheckbox
                    label={label}
                    checked={draftSelectedMetrics.includes(value)}
                    onChange={() => handleToggleMetric(value)}
                    maxWidth="100%"
                  />
                </div>
                <div
                  className={cls(
                    'transition-all duration-200 flex items-center',
                    isHovered || snapshot.isDragging ? 'flex' : 'hidden',
                  )}
                >
                  <GTooltipCard tooltip={tooltip} isHideBorder>
                    <Box>
                      <Icon source={InfoIcon} />
                    </Box>
                  </GTooltipCard>
                  <div {...provided.dragHandleProps} className="flex items-center cursor-pointer">
                    <Icon source={DragHandleIcon} />
                  </div>
                </div>
              </div>
            </GDiv>
          );
        }}
      </Draggable>
    );
  },
);
